/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import './styles.scss';
import _ from 'lodash';

type PropsType = {
  fileLinksData: {
    fileLinks: string[],
    fileType: string
  } | null,
  tabName: string,
  handleClearLinksData: (boolean) => void
};

class EventPageDetailLinksModal extends React.Component<PropsType> {
  handleClose = (): any => {
    const { handleClearLinksData } = this.props;

    handleClearLinksData();
  };

  render(): React.Element {
    const { tabName, fileLinksData: { fileLinks, fileType } } = this.props;

    return (
      <Modal
        opened
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div className="modal-dialog customModal EventPageDetailCustomersModal modal-table-filter" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>Export file is too big</span>
              </h4>
            </div>
            <div className="modal-body" style={{ padding: '2rem 0 1rem' }}>

              <div className="container-fluid">
                The data set is too big to export in one file. You can download separated files:
                <ul>
                  {_.map(fileLinks, (link: string, count: number): React.Element<'li'> => (
                    <li key={count} style={{ padding: '8px 0' }}>
                      <a href={link} target='_blank'>
                        {`${tabName.charAt(0).toUpperCase() + tabName.slice(1)}_exports_${count + 1}.${fileType}`
                        }</a>
                    </li>
                  ))}
                </ul>
              </div>

            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailLinksModal;
